import { forwardRef, type ComponentProps, type ReactElement } from 'react';

import { Svg } from './Svg.tsx';

type SvgImageProps = Omit<ComponentProps<typeof Svg>, 'children'>;

/** @deprecated use `import Component from '../path/component?styled'` instead */
export const makeSvgImage = (svg: ReactElement) =>
  forwardRef<SVGSVGElement, SvgImageProps>(({ ...props }, ref) => (
    <Svg ref={ref} {...(svg.props as any)} {...props} />
  ));
